"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  name: "Antrim",
  code: "AN"
}, {
  name: "Armagh",
  code: "AR"
}, {
  name: "Carlow",
  code: "CW"
}, {
  name: "Cavan",
  code: "CN"
}, {
  name: "Clare",
  code: "CE"
}, {
  name: "Cork",
  code: "C"
}, {
  name: "Derry",
  code: "LD"
}, {
  name: "Donegal",
  code: "DL"
}, {
  name: "Down",
  code: "DN"
}, {
  name: "Dublin",
  code: "D"
}, {
  name: "Fermanagh",
  code: "FE"
}, {
  name: "Galway",
  code: "G"
}, {
  name: "Kerry",
  code: "KY"
}, {
  name: "Kildare",
  code: "KE"
}, {
  name: "Kilkenny",
  code: "KK"
}, {
  name: "Laois",
  code: "LS"
}, {
  name: "Leitrim",
  code: "LM"
}, {
  name: "Limerick",
  code: "L"
}, {
  name: "Longford",
  code: "LD"
}, {
  name: "Louth",
  code: "LH"
}, {
  name: "Mayo",
  code: "MO"
}, {
  name: "Meath",
  code: "MH"
}, {
  name: "Monaghan",
  code: "MN"
}, {
  name: "Offaly",
  code: "OY"
}, {
  name: "Roscommon",
  code: "RN"
}, {
  name: "Sligo",
  code: "SO"
}, {
  name: "Tipperary",
  code: "TS"
}, {
  name: "Tyrone",
  code: "TY"
}, {
  name: "Waterford",
  code: "WD"
}, {
  name: "Westmeath",
  code: "WH"
}, {
  name: "Wexford",
  code: "WX"
}, {
  name: "Wicklow",
  code: "WW"
}];
exports.default = _default;